<template>
  <div class="step-container form">
    <div class="row center">
      <h3 class="step-header">6. Accept the terms below</h3>
    </div>
    <div class="row center">
      <h4 class="step-sub-header">You can get cover immediately, just click through</h4>
    </div>
    <div class="row">
      <div class="header">
        <h2>{{ plan.plan_name }}</h2>
        <h3><span>£{{ (plan.monthly_amount + upcost - discountAmount).toFixed(2) }}</span> <small>per month.</small>
        </h3>
        <small>See below what's included.</small>
        <p>
          Your first payment will be taken on the first working day of the month.
          Your contract will last 12 months. We will email you a reminder before your
          annual renewal. Payments will be taken via Direct Debit.
        </p>
      </div>
    </div>
    <div class="row center spaced">
      <img :src="`${base}images/direct_debit_logo.jpg`" alt="Direct Debit">
    </div>
    <validation-observer v-slot="{ handleSubmit }">
      <form ref="form" :action="`${base}/calculator/redirect`" method="post" enctype="multipart/form-data"
            @submit.prevent="handleSubmit(submit)">
        <div class="row">
          <input type="text" name="first_name" class="hidden" v-model="firstName">
          <input type="text" name="last_name" class="hidden" v-model="lastName">
          <input type="text" name="email" class="hidden" v-model="email">
          <input type="text" name="phone_number" class="hidden" v-model="phone">
          <input type="text" name="cover_plan_id" class="hidden" v-model="plan.id">
          <input type="text" name="upcosts" class="hidden" v-model="upcostList">
          <input v-if="discountModel" type="text" name="reference_code_id" class="hidden" v-model="discountModel.id">
        </div>
        <div class="row">
          <label for="discount" class="form-input flex">
            <input type="text" id="discount" name="discount" placeholder="Reference Code" v-model="discount">
            <button @click.prevent="checkDiscount">Apply</button>
          </label>
          <p v-if="discountState === 1" class="error-message">Reference code {{ applied }} is not valid</p>
          <p v-else-if="discountState === 2" class="success-message">Reference code {{ applied }} applied</p>

        </div>
        <div class="row center">
          <validation-provider class="provider" v-slot="{ errors }" name="terms and conditions"
                               :rules="{ required: { allowFalse: false } }" slim>
            <label for="terms" class="checkbox">
              <input type="checkbox" id="terms" v-model="terms">
              <span
                  :class="{ error: errors.length }">Please confirm you have read and accept the
                <a target="_blank" href="https://auragas.co.uk/auragas-care-plan-terms-and-conditions">
                terms & conditions
              </a>
              </span>
            </label>
          </validation-provider>
        </div>
        <div class="row center">
          <validation-provider class="provider" v-slot="{ errors }" name="working confirmation"
                               :rules="{ required: { allowFalse: false } }" slim>
            <label for="working" class="checkbox">
              <input type="checkbox" id="working" v-model="working">
              <span :class="{ error: errors.length }">Please confirm your boiler and heating system is in full working order</span>
            </label>
          </validation-provider>
        </div>
        <div class="row center">
          <div class="total">
            Total £{{ (plan.monthly_amount + upcost - discountAmount).toFixed(2) }} per month
          </div>
        </div>
        <div class="row center spaced">
          <button type="submit" class="submit-button"><span>Proceed</span></button>
        </div>
        <div class="row center back">
          <span @click="$emit('back')">Back</span>
        </div>
      </form>
      <div class="row logos">
        <span>
          <img :src="`${base}images/credit_card_icons.png`" alt="Pay by card">
        </span>
        <span>
          <img :src="`${base}images/trust_pilot.png`" alt="Trust Pilot - Excellent">
        </span>
        <a href="https://www.worcester-bosch.co.uk/" target="_blank">
          <img :src="`${base}images/worcester_logo.jpg`" alt="Worcester - Bosch Group">
        </a>
        <a href="https://trustedtraders.which.co.uk/" target="_blank">
          <img :src="`${base}images/which_logo.jpg`" alt="Which? trusted trader">
        </a>
        <a href="https://www.gassaferegister.co.uk/" target="_blank">
          <img :src="`${base}images/gas_safe.jpg`" alt="Gas safe registered">
        </a>
      </div>
      <h2 class="included-heading"><img class="included-icon" :src="`${base}images/included.png`" alt="included icon">
        What's included in my care plan?</h2>
      <div class="features">
        <ul class="bullet-points">
          <li v-for="feature in features" :key="feature.id">
            <span class="material-icons green" v-if="checkIncludes(feature.id)">check_circle_outline</span>
            <span class="material-icons red" v-else>highlight_off</span>
            <span>{{ feature.name }}</span>
          </li>
        </ul>
      </div>

    </validation-observer>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver
} from 'vee-validate/dist/vee-validate.full';

export default {
  name: "StepFive",
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    base: {
      type: String,
      required: true,
    },
    firstName: {
      type: String,
      required: true,
    },
    lastName: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
    phone: {
      type: String,
      default: '',
    },
    plan: {
      type: Object,
      required: true,
    },
    upcost: {
      type: Number,
      default: 0,
    },
    fuel: {
      type: String,
      default: '',
    },
    ownership: {
      type: String,
      default: '',
    },
    guarantee: {
      type: Number,
      default: null,
    },
    features: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      discount: '',
      terms: false,
      working: false,
      discountAmount: 0,
      discountState: 0,
      discountModel: null,
      applied: '',
    }
  },
  methods: {
    submit() {
      if (this.discountState !== 1) {
        window.dataLayer.push({
          event: 'boilerCoverDirectDebitReached',
          category: 'Boiler Cover Calculator',
          action: 'Reached Direct Debit Stage',
          label: 'Boiler Cover Plan Direct Debit Reached',
          boilerPlanType: this.plan.name,
        });
        this.$refs['form'].submit();
      }
    },
    checkDiscount() {
      this.applied = '';
      if (!this.discount.length) {
        this.discountState = 0;
      } else {
        this.$axios.post(`${this.base}/calculator/discount/check`, this.$makeForm({
          code: this.discount,
          plan_id: this.plan.id
        }))
            .then(response => {
              if (response.data.reference_code) {
                this.discountAmount = this.calculateDiscount(response.data.reference_code.value);
                this.discountState = 2;
                this.applied = this.discount;
                this.discountModel = response.data.reference_code;
              } else {
                this.discountAmount = 0;
                this.discountState = 1;
                this.applied = this.discount;
                this.discountModel = null;
              }

            }).catch((error) => {
          this.discountAmount = 0;
          this.discountState = 0;
          this.applied = this.discount;
          this.discountModel = null;
        });
      }
    },
    calculateDiscount(value) {
      let remove = 0;
      if (value.toString().includes('%')) {
        remove = value.slice(0, -1);
        if (parseFloat(remove) > 0) {
          return (parseFloat(remove) / 100) * (parseFloat(this.plan.monthly_amount) + this.upcost);
        } else {
          return -1 * (parseFloat(remove) / 100) * (parseFloat(this.plan.monthly_amount) + this.upcost);
        }
      } else {
        if (parseFloat(value) > 0) {
          return parseFloat(value);
        } else {
          return -1 * parseFloat(value);
        }
      }
    },
    checkIncludes(id) {
      for (let i = 0; i < this.plan.features.length; i++) {
        if (this.plan.features[i].id === id) {
          return true;
        }
      }
      return false;
    }
  },
  computed: {
    upcostList() {
      return `${this.ownership},${this.fuel}`;
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  max-width: 1000px;
  margin-left: auto !important;
  margin-right: auto !important;
}

h2 {
  font-size: 1.8rem;
  display: block;
  color: #444444;
  font-weight: normal;
  text-align: center;
  margin: 1rem 0;

  &::before {
    display: none;
  }
}

.header {
  text-align: center;
  margin: 0 auto;

  h3 {
    margin: 0.5rem;

    span {
      text-decoration: underline;
      font-size: 3rem;
      color: #444444;
      font-weight: bold;
    }

    small {
      font-size: 1.5rem;
      color: #444444;
      font-weight: normal;
    }
  }

  small {
    color: #444444;
  }

  p {
    margin: 1rem 0;
    padding: 0 20%;
    line-height: 1.5rem;
  }

}

form {
  padding: 0 20%;
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  box-sizing: border-box;
}

.form-input {
  width: 100%;
  margin: 0.5rem 0;
  display: block;

  &.flex {
    display: flex;
    justify-content: space-between;
    width: 100%;

    input {
      width: 90%;
      font-family: sans-serif;
      padding: 0.5rem 0.4rem;
      border: 1px solid #000;
      outline: none;
    }

    button {
      background-color: #FF5B18;
      color: #FFF;
      padding: 0 1rem;
      border-radius: 5px;
      cursor: pointer;
      border: none;
      outline: none;
      margin-left: 1rem;
    }
  }

  input {
    width: 100%;
    font-family: sans-serif;
    padding: 0.5rem 0.4rem;
    border: 1px solid #000;
    outline: none;

    &.error {
      border: 1px solid red;
    }
  }

  &.half {
    width: 49%;
  }
}

.checkbox {
  margin: 0.5rem 0;

  span.error {
    color: red;
  }

  input {
    margin-right: 0.2rem;
  }
}

.total {
  margin-top: 2rem;
  padding: 0.5rem 1rem;
  border: 1px solid #444444;
  color: #444444;
  font-size: 1.5rem;
  font-weight: normal;
}

.provider {
  width: 100%;
}

.logos {
  margin: 1rem 20%;
  width: 60%;
  justify-content: center;

  a, span {
    margin: 0.5rem;

    img {
      height: 40px;
      transition: 0.4s;
    }

    &:hover {
      img {
        transform: scale(1.1);
        transition: 0.4s;
      }
    }
  }
}

.features {
  background-color: #F5F5F5;
  padding: 0.5rem 1rem;
  margin: 1rem 20%;

  .bullet-points {
    margin: 0;
    text-align: left;
    list-style: none;

    li {
      padding-bottom: 0.2rem;
      margin-bottom: 0.2rem;
      border-bottom: 1px dashed #D3D3D3;
      font-size: 1.2rem;
      display: flex;

      .material-icons {
        margin-right: 0.5rem;
      }
    }
  }
}

.spaced {
  margin: 2rem 0;
}

.red {
  color: red;
}

.green {
  color: green;
}

.hidden {
  display: none;
}

.success-message {
  color: green;
  margin: 0.5rem 0;
}

.error-message {
  color: red;
  margin: 0.5rem 0;
}

.included-heading {
  display: flex;
  align-items: center;
  justify-content: center;

  .included-icon {
    width: 50px;
    height: 50px;
    margin-right: 0.2rem;
  }
}


@media only screen and (max-width: 860px) {
  form {
    padding: 0 10px;
  }
  .form-input {
    &.half {
      width: 100%;
    }
  }
  .logos {
    margin: 1rem 10px;
    width: 100%;
    justify-content: center;
  }

  .features {
    background-color: #F5F5F5;
    padding: 0.5rem 1rem;
    margin: 1rem 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/steps/StepSix.vue